<template>
<div class="">
  <!-- <vue-headful
    :title="'New Reaction'"
/> -->
<!-- <vue-headful
  :title="'💌 to '+ $route.params.name"
/> -->
  <h1>Ask the city for their opinion</h1>
  <div>
    <input placeholder="Your question here" type="text"
      v-model="newemoji"
      @keyup.enter="addemoji">
    <button  @click="addemoji">
      Add question
    </button>
  </div>

</div>
</template>

<script>

import { db } from '../firebase';

  export default {
    name: 'collection',
    data() {
      return {
        emojis: [],
        newemoji: '',
        msg: 'Collection',
        location: String
      }
    },
    firestore() {
      return {
        emojis: db.collection(this.location),
      }
    },
    methods: {
      addemoji: function() {
        this.$firestore.emojis.add(
          {
            name: this.newemoji,
            timestamp: new Date()
          }
        );
        this.newemoji = '';
      },

      deleteemoji: function(emoji) {
        this.$firestore.emojis.doc(emoji['.key']).delete();
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #FF4166;
    margin-top: 60px;
  }
  .emojiList {
    list-style: none;
  }
</style>
